import { GetStaticProps } from 'next';
import { PassengersPageId } from '../../../features/app/pages/domain/constants/PageId';
import { createGetStaticPropsWithPage } from '../../../features/app/root/domain/use-cases/createGetStaticPropsWithPage';
import { getStaticPathsForLocales } from '../../../features/app/pages/domain/use-cases/getStaticPathsForLocales';
import { IAccountPageData } from '../../../features/account/domain/pages/IAccountPageData';
import { RewardOffersPage } from '../../../features/account/ui/account-offers/ui/RewardOffersPage';

export const getStaticPaths = getStaticPathsForLocales;

export const getStaticProps: GetStaticProps<IAccountPageData> =
	createGetStaticPropsWithPage(PassengersPageId.RewardOffers);

export default RewardOffersPage;
